import * as React from 'react';
import { Car16, Walk16 } from '@cian/ui-kit/icons';
import { Header1, InlineText2 } from '@cian/ui-kit/typography';
import { ETransportType, IEcology } from '../../../../types/newbuilding/ecology';
import * as style from './SlideInfo.css';

interface ISlideInfoProps {
  ecology: IEcology | undefined;
}

export const SlideInfo: React.StatelessComponent<ISlideInfoProps> = props => {
  const { ecology } = props;

  if (!ecology) {
    return null;
  }

  const Icon = ecology.transportType === ETransportType.Walk ? Walk16 : Car16;

  return (
    <div className={style['info']}>
      <Header1 color={'white_100'} fontWeight={'bold'}>
        {ecology.title}
      </Header1>
      {ecology.title && ecology.transportType && (
        <div className={style['distance']}>
          <InlineText2 color={'white_100'}>Расстояние от комплекса:</InlineText2>
          <div className={style['icon']}>
            <Icon color={'white_100'} />
          </div>
          <InlineText2 color={'white_100'}>{ecology.distance}</InlineText2>
        </div>
      )}
    </div>
  );
};
